import { Form } from "@circle-react-uikit/Form";
import { useModalData } from "@circle-react-uikit/ModalV2";
import { useSpaceGroupsContext } from "@circle-react/contexts/spaceGroupsContext";

import { t } from "@/i18n-js/instance";
import { SpaceGroupSelect } from "@/react/components/SettingsApp/CompassCompat/SpaceGroupSelect";

export const SpaceGroupField = () => {
  const { records: spaceGroups } = useSpaceGroupsContext();
  const { contentPortalElement } = useModalData();

  return (
    <Form.Item
      name="space_group_id"
      translationRoot="spaces.form.create.basic_info"
      hideDescription
      rules={{
        required: t("spaces.form.create.v4.errors.space_group_id_required"),
      }}
      hideBorder
      fullWidth
      layout="horizontal"
      horizontalLayoutRatio="30/70"
      variant="extra-bottom-margin"
    >
      <SpaceGroupSelect
        variant="form-input"
        spaceGroups={spaceGroups}
        name="space_group_id"
        appendTo={contentPortalElement}
      />
    </Form.Item>
  );
};
